import { useContext, useState } from 'react';
import useFetch from '../../../hooks/useFetch';
import { EndPoints } from '../EndPoints';
import { ServiceEvents } from '../shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';

const useQuoteInvoicingService = () => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { doGet, doPut } = useFetch();

    const [fetchingEditQuoteInvoicing, setFetchingEditQuoteInvoicing] = useState(false);
    const [fetchingUpdateQuoteInvoicing, setFetchingUpdateQuoteInvoicing] = useState(false);
    const [fetchingQuoteInvoicingByQuote, setFetchingQuoteInvoicingByQuote] = useState(false);

    const editQuoteInvoicing = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.QUOTE_INVOICING.EDIT_QUOTE_INVOICING.replace(':id', id.toString()),
            setFetching: setFetchingEditQuoteInvoicing
        });
    };

    const updateQuoteInvoicing = (
        id: number,
        data: any,
        events: ServiceEvents = {}
    ) => {
        doPut({
            ...events,
            url: EndPoints.QUOTE_INVOICING.UPDATE_QUOTE_INVOICING.replace(':id', id.toString()),
            body: data,
            setFetching: setFetchingUpdateQuoteInvoicing
        });
    };

    const getQuoteInvoicingByQuote = (
        quoteId: number,
        mode: 'view' | 'edit' = 'view', // modo opcional
        events: ServiceEvents = {}
    ) => {
        const url = `${EndPoints.QUOTE_INVOICING.GET_QUOTE_INVOICING_BY_QUOTE.replace(':id', quoteId.toString())}?mode=${mode}`;

        doGet({
            ...events,
            url,
            setFetching: setFetchingQuoteInvoicingByQuote
        });
    };

    return {
        editQuoteInvoicing,
        updateQuoteInvoicing,
        getQuoteInvoicingByQuote,
        fetchingEditQuoteInvoicing,
        fetchingUpdateQuoteInvoicing,
        fetchingQuoteInvoicingByQuote
    };
};

export default useQuoteInvoicingService;
